export const ACTION = {
    GET_ACCOUNT_LIST: 'GET_ACCOUNT_LIST',
    POST_SWITCH_ACCOUNT_REQ: 'POST_SWITCH_ACCOUNT_REQ',
    RESET_SWITCH_ACCOUNT_DATA: 'RESET_SWITCH_ACCOUNT_DATA',
};